import { environment } from '@env/environment';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import moment from 'moment';

@Component({
  selector: 'app-modal-rooms',
  templateUrl: './modal-rooms.component.html',
  styleUrls: ['./modal-rooms.component.scss'],
})
export class ModalRoomsComponent implements OnInit {
  @Input() rooms: any;
  reservation: any;
  public environment = environment;
  today = moment().format('LL')
  tomorrow = moment().add(1, 'day').format('LL')
  constructor(
    public storage: Storage,
    private modalCtrlr: ModalController,) { }

  async ngOnInit() {
    console.log(this.rooms)
    this.reservation = await this.storage.get("reservationData");
  }

  chooseRoom(room){
    this.storage.set('roomSelected', room);
    this.modalCtrlr.dismiss()
  }
}
